module.exports = __webpack_public_path__ + "static/media/ic-search-thin.c581df96.svg";